<template>
    <div class="subscribers--container">
        <data-container>
            <template #controls>
                    <AppDropdown
                        placeholder="Select"
                        v-model="filter.sort_by"
                        :options="sortItems"
                        :disabled="isLoading"
                        @input="fetchSubscriberPlan"
                    >
                        Sort by
                    </AppDropdown>
                    <div class="right--controls">
                        <AppButton modifier="small-primary" @click="$router.push({ name: 'SubscriberPlansCreate' })">
                            Create Plan
                        </AppButton>
                        <AppTextField
                            v-model="filter.search"
                            placeholder="Type here"
                            icon-right="search"
                            @input="search"
                        />
                    </div>
            </template>
            <template #content>
                <AppTable
                    :dataset="subscriberPlansList.data"
                    :fields="fields"
                    :loading="isLoading"
                    :selected="selectedItems"
                    @select="selectedItems = $event"
                    @endOfScroll="meszsage('end of scroll')"
                    :total-count="subscriberPlansList.total"
                    :current-page="parseInt(filter.page)"
                    :items-per-page="parseInt(filter.count)"
                    @changePage="changePage"
                >

                    <template #price="{ props }">
                        {{ props.item.price ? `&#36; ${props.item.price}` : '--' }}
                    </template>
                    <template #action="{ props }">
                        <AppButton modifier="icon small-primary" @click="edit(props.item.id)">
                            <img src="@/assets/img/ic-edit.svg" class="icon">
                        </AppButton>
                    </template>
                </AppTable>

            </template>
        </data-container>
    </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import AppDropdown from '@/components/AppDropdown'
import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import AppTable from '@/components/AppTable'
import { subscriberPlansFields, sortItems } from '@/utils/meta.js'
import subscriberPlan from '@/store/subscriber-plan/app.js'
import { setQueryParams } from '@/utils/helpers.js'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			selectedItems: []
		}
	},
	methods: {
		search (val) {
			this.filter.page = 1
			this.filter.keyword = val
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.fetchSubscriberPlan()
			}, 300)
		},

		fetchSubscriberPlan () {
		    const query = { ...this.filter }
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			this.$router.push({ query })
			const queryStr = setQueryParams(this.filter)
		    this.$store.dispatch('subscriberPlan/list', queryStr.toLowerCase())
		},

		changePage ({ currentPage, itemsPerPage }) {
			this.filter.page = currentPage
			itemsPerPage !== this.filter.count && (this.filter.page = 1)
			this.filter.count = itemsPerPage
			this.fetchSubscriberPlan()
		},

		edit (id) {
			this.$router.push({ name: 'SubscriberPlansEdit', params: { id } })
		}
	},
	created () {
		this.$store.dispatch('subscriberPlan/clearPlan')
		const query = { ...this.$route.query }
		if (Object.keys(query).length) {
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			this.filter = { ...query }
		}
		this.fetchSubscriberPlan()
	},
	computed: {
		...mapGetters('subscriberPlan', [
			'subscriberPlansList',
			'isLoading'
		]),
		...mapFields('subscriberPlan', [
			'filter',
			'progress'
		]),
		fields () { return subscriberPlansFields },
		sortItems () { return sortItems },
		subscriberPageCounter () {
		// const { to, from } = this.data
		// return `${from || 0} - ${to || 0}`
			return '0 - 0'
		},
		accounts () {
			return [
				{ name: 'Name1', email: 'email1', id: '1' },
				{ name: 'Name2', email: 'email2', id: '2' },
				{ name: 'Name3', email: 'email3', id: '3' }
			]
		},
		plans () {
			return [
				{ text: 'Name1', val: '1' },
				{ text: 'Name2', val: '2' },
				{ text: 'Name3', val: '3' }
			]
		}
	},
	beforeCreate () {
		if (!this.$store.hasModule('subscriberPlan')) {
			this.$store.registerModule('subscriberPlan', subscriberPlan)
		}
	},
	components: {
		DataContainer,
		AppDropdown,
		AppButton,
		AppTextField,
		AppTable
	}
}
</script>

<style lang="scss" scoped>
.subscribers--container {
    padding: 1.5em;
}

.binding-form {
    width: 100%;

    label {
        color: $dark;
        margin: 10px 0;
        display: block;
    }

    .app-dropdown {
        width: 100%;

        .account {
            width: 100%;
            padding: 8px 0;

            span {
                display: block;
                margin-top: 8px;
            }
        }
    }
}

.custom-table {
    margin-top: 12px;
}

.right--controls{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    .app-button--small-primary {
        margin-right: 12px;
    }
}

/deep/ .app-popup {
    width: 30em;
    padding: 16px 0;
}

.app-count-picker {
    margin-right: 5px;
}

.pagination--counter {
    display: flex;
    flex: 1;
    font-size: 1.2em;
}
</style>
